module.exports = __webpack_public_path__ + "img/tkn.a407b2c6.svg";